import { ApiErrorCodes } from "@financeable/lenders/models/components";
import { Stack, Typography, styled } from "@financeable-com-au/financeable-ui";
import { useLenderError } from "@/components/SubmissionModal/hooks/useLenderError";
import { useApplicationRouteType } from "@/components/SubmissionModal/hooks/useApplicationRouteType";

const Code = styled("code")`
  word-break: break-word;
`;

const ErrorMessage = () => {
  const { errorGroupByCode, errorHasKnownCode, fallbackMessage } = useLenderError();
  const applicationRouteType = useApplicationRouteType();

  return (
    <Stack rowGap={3}>
      <Typography>Unfortunately, your {applicationRouteType} was not uploaded.</Typography>
      {errorHasKnownCode ? (
        <>
          {errorGroupByCode[ApiErrorCodes.ValidationError] !== undefined && (
            <Stack>
              <Typography mb={1}>The following fields are invalid:</Typography>
              {errorGroupByCode[ApiErrorCodes.ValidationError]?.map((item, index) => {
                return (
                  <Typography level="body-xs" key={index}>
                    <Code>
                      {item.detail}
                      {item.source?.pointer !== "unknown" ? `: ${item.source?.pointer}` : ""}
                    </Code>
                  </Typography>
                );
              })}
            </Stack>
          )}
          {errorGroupByCode[ApiErrorCodes.DataMappingError] !== undefined && (
            <Stack>
              <Typography mb={1}>The following fields are incorrectly mapped:</Typography>
              {errorGroupByCode[ApiErrorCodes.DataMappingError]?.map((item, index) => {
                return (
                  <Typography level="body-xs" key={index}>
                    <Code>
                      {item.detail}
                      {item.source?.pointer !== "unknown" ? `: ${item.source?.pointer}` : ""}
                    </Code>
                  </Typography>
                );
              })}
            </Stack>
          )}
          {errorGroupByCode[ApiErrorCodes.ExternalApiError] !== undefined && (
            <Stack>
              <Typography mb={1}>There was an error with the lender.</Typography>
            </Stack>
          )}
        </>
      ) : (
        <Typography level="body-xs">
          <Code>{fallbackMessage}</Code>
        </Typography>
      )}
    </Stack>
  );
};

export { ErrorMessage };
